import React, { useContext, useEffect, useState } from "react";
import {
  calculatePayableAmount,
  calculateStayDuration,
  confirmcheckOut,
  getCredit,
  getCurrentLocalDateTime,
} from "../utils/helperFunctions";
import { toast } from "react-toastify";
import { Mycontext } from "../context/context";
import { useSearchParams } from "react-router-dom";
import { format, isAfter } from "date-fns";

const CheckoutModal = ({ checkOutData, action }) => {
  const localISOTime = getCurrentLocalDateTime();
  const [checkoutDateTime, setCheckoutDateTime] = useState(localISOTime.dateTime);
  const [checkoutdetails, setCheckoutdetails] = useState({
    checkIn: "",
    checkOutDate: "",
    checkOutTime: "",
    stayHours: "",
    payableHours: "",
    payableAmount: "",
    paymentMethod: "cash",
    paidAmount: "",
    notes: "",
    returnAmount: 0,
    advancePayAmount: 0,
  });
  const [isLoading, setIsLoading] = useState(false); 
  const [searchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get("page")) || 1;
  const { formToShow, setFormToShow ,setCreditBalance, setHotelName,setCreditToupdate } = useContext(Mycontext);

  const isOverpaid =
    (checkoutdetails.payableAmount || 0) -
      (checkoutdetails.advancePayAmount || 0) <
    0;
  const handleDateChange = (e) => {
    const date = e.target.value;
    const now = localISOTime.dateTime;
    const checkInDateTime = new Date(
      `${checkOutData.checkInDate?.split("T")[0]}T${checkOutData.checkInTime}`
    );

    // Parse selected checkout datetime
    const selectedCheckout = new Date(date);
    if (isAfter(date, now) || selectedCheckout <= checkInDateTime) {
      setCheckoutDateTime(now);
    } else {
      setCheckoutDateTime(date);
    }
  };

  // useEffect(() => {
  //   fetchGuestDetails();
  // }, []);

  useEffect(() => {
    if (checkoutDateTime && checkOutData) {
      const checkInDateTime = new Date(
        `${checkOutData.checkInDate?.split("T")[0]}T${
          checkOutData.checkInTime
        }`
      );
      
      const checkIn = new Date(checkInDateTime);
      const checkOut = new Date(checkoutDateTime);

      const stayHours = calculateStayDuration(checkIn, checkOut);
      const { payableHours, payableAmount } = calculatePayableAmount(
        stayHours,
        checkOutData.gracePeriod,
        checkOutData.hourlyPricing,
        checkIn,
        checkOut,
        checkOutData.nightCheckInConfirmed,
        checkOutData.nightStayPrice
      );

      const remainingAmount = payableAmount - checkOutData.advancePayAmount;

      setCheckoutdetails((prev) => ({
        ...prev,
        checkIn: checkOutData.checkInId,
        checkOutDate: checkoutDateTime.split("T")[0],
        checkOutTime: checkoutDateTime.split("T")[1],
        stayHours,
        payableHours,
        payableAmount,
        paidAmount: remainingAmount > 0 ? remainingAmount : 0,
        returnAmount: remainingAmount < 0 ? Math.abs(remainingAmount) : 0,
        advancePayAmount: checkOutData.advancePayAmount,
      }));
    }
  }, [checkOutData, checkoutDateTime]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && formToShow === "formB") {
        setFormToShow(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formToShow]);


  const handleConfirmCheckout = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    try {
      const confirmation = await confirmcheckOut(checkoutdetails);

      if (confirmation?.data?.status) {
        // setExtval(confirmation?.data?.data);
        toast.success(confirmation.data.msg);
        setCreditToupdate(true);
         // After successful checkout, refresh credit balance
      // const creditResponse = await getCredit();
      // if (creditResponse.status) {
      //   setCreditBalance(creditResponse.data.creditBalance);
      //   setHotelName(creditResponse.data.hotelName);
      // }
        await action(initialPage);
        setFormToShow(null);
        setCheckoutDateTime(localISOTime.dateTime);
        setCheckoutdetails({
          checkIn: "",
          checkOutDate: "",
          checkOutTime: "",
          stayHours: "",
          payableHours: "",
          payableAmount: "",
          paymentMethod: "cash",
          paidAmount: "",
          notes: "",
        });
      }
    } catch (error) {
      toast.error(error.response.data.msg);
    } finally {
      setIsLoading(false);
    }
  };

  if (!formToShow === "formB") return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div
            className="absolute inset-0 bg-gray-500 opacity-75"
            onClick={() => {
              if (!isLoading) {
                setFormToShow(null);
              }
            }}
          ></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full mx-2 sm:mx-0">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4 text-center">
              Confirm Checkout
            </h3>

            <form onSubmit={handleConfirmCheckout} className="space-y-4">
              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-3 sm:p-4 rounded-lg">
                <div className="space-y-3 sm:space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Checkout Date & Time *
                    </label>
                    <div className="relative w-full">
                      <input
                        type="text"
                        value={
                          checkoutDateTime
                            ? format(
                                new Date(checkoutDateTime),
                                "dd/MM/yyyy hh:mm a"
                              )
                            : ""
                        }
                        readOnly
                        onClick={() =>
                          !isLoading && document
                            .getElementById("checkout-picker")
                            .showPicker()
                        }
                        className="absolute top-0 left-0 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm z-10"
                      />
                      <input
                        type="datetime-local"
                        id="checkout-picker"
                        name="checkoutDateTime"
                        value={checkoutDateTime}
                        // min={minvalue}
                        max={localISOTime.dateTime}
                        onChange={handleDateChange}
                        required
                        className="w-full px-0 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-transparent text-transparent caret-transparent z-0"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-3 sm:p-4 rounded-lg">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Stay Duration (hours)
                    </label>
                    <input
                      type="text"
                      value={checkoutdetails.stayHours}
                      readOnly
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Payable Hours
                      {checkOutData.nightCheckInConfirmed &&
                        "(after night stay)"}
                    </label>
                    <input
                      type="text"
                      value={checkoutdetails.payableHours}
                      readOnly
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Payable Amount
                    </label>
                    <input
                      type="text"
                      value={checkoutdetails.payableAmount}
                      readOnly
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Advance Paid
                    </label>
                    <input
                      type="text"
                      value={checkoutdetails.advancePayAmount || 0}
                      readOnly
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                    />
                  </div>

                  {isOverpaid ? (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Overpaid Amount
                      </label>
                      <input
                        type="text"
                        value={checkoutdetails.returnAmount}
                        readOnly
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                      />
                    </div>
                  ) : (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Remaining Amount
                      </label>
                      <input
                        type="text"
                        value={checkoutdetails.paidAmount}
                        readOnly
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
                      />
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Payment Method *
                    </label>
                    <select
                      value={checkoutdetails.paymentMethod}
                      onChange={(e) =>
                        setCheckoutdetails((prev) => ({
                          ...prev,
                          paymentMethod: e.target.value,
                        }))
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                      required
                    >
                      <option value="cash">Cash</option>
                      <option value="online">Online</option>
                    </select>
                  </div>

                  {isOverpaid ? (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Return Amount *
                      </label>
                      <input
                        type="number"
                        min="0"
                        value={checkoutdetails.returnAmount}
                        onChange={(e) =>
                          setCheckoutdetails((prev) => ({
                            ...prev,
                            returnAmount: e.target.value,
                          }))
                        }
                        onWheel={(e) => e.target.blur()}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        required
                      />
                    </div>
                  ) : (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Paid Amount *
                      </label>
                      <input
                        type="number"
                        min="0"
                        value={checkoutdetails.paidAmount}
                        onChange={(e) =>
                          setCheckoutdetails((prev) => ({
                            ...prev,
                            paidAmount: e.target.value,
                          }))
                        }
                        onWheel={(e) => e.target.blur()}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        required
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-3 sm:p-4 rounded-lg">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Notes
                  </label>
                  <textarea
                    value={checkoutdetails?.notes || ""}
                    onChange={(e) =>
                      setCheckoutdetails((prev) => ({
                        ...prev,
                        notes: e.target.value,
                      }))
                    }
                    placeholder="Add any notes here..."
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 resize-none"
                    rows="3"
                  />
                </div>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                {/* <button
                  disabled={isLoading}
                  type="submit"
                  className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none"
                >
                  Confirm
                </button> */}
                  <button
                  type="submit"
                  disabled={isLoading}
                  className={`inline-flex justify-center items-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none ${
                    isLoading
                      ? "bg-indigo-400 cursor-not-allowed"
                      : "bg-indigo-600 hover:bg-indigo-700"
                  }`}
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processing...
                    </>
                  ) : (
                    "Confirm Checkout"
                  )}
                </button>
                <button
                  type="button"
                  disabled={isLoading}
                  onClick={() => {setFormToShow(null)}}
                  className="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
